var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- THIS IS A TESTING FILE ONLY, manage_settings.jst MUST BE DECLARED IN YOUR CONNECT APP BACKDRAFT APP -->\n<h1 class="pageTitle">'+
((__t=( pageTitle ))==null?'':__t)+
'</h1>\n<div class="panel panel-default">\n  <div class="panel-body">\n    <form>\n      <div class="form-group row">\n        <div class="col-md-6">\n          <label class="control-label">Some Label</label>\n          <input id="approved-ad-account-id" name="approved_ad_account_id" class="form-control col-md-3" disabled="disabled" />\n        </div>\n      </div>\n      <div class="form-group row">\n        <div id="manage_objects_container" class="col-md-6">\n          <label class="control-label">Settings</label>\n        </div>\n      </div>\n    </form>\n  </div>\n  <div class="panel-footer">\n    ';
 if (isNew) { 
__p+='\n    <button id="submit" class="btn btn-primary">Done</button>\n    ';
 } else { 
__p+='\n    <p id="deactivate-text">You may <a id="deactivate-link" href="#">de-activate this integration</a> at any time.</p>\n    <p>Note: to switch accounts, you must disable this account and authorize a new Facebook account.</p>\n    ';
 } 
__p+='\n  </div>\n</div>\n';
}
return __p;
};
